// @flow
import { useContext } from 'react';

import ReactAppContext from 'Context/ReactAppContext';
import { ReactPageContext } from 'Context/pageContext';
import * as trackingApi from 'Tracking/tracking-api';
import { GA_DEFAULT_PAYLOAD } from 'Tracking/constants';

type TrackingAttribute = string | number | boolean | null;

export type TrackingPayload = $ReadOnly<{
  categoryGA?: string,
  actionGA?: string,
  labelGA?: string,
  user?: { neolaneID: string },
  [string]: ?TrackingAttribute | ?Array<{ [string]: ?TrackingAttribute }>,
}>;

export const useTracking = (defaultPayload?: TrackingPayload) => {
  const appContext = useContext(ReactAppContext);
  const pageContext = useContext(ReactPageContext);
  const payload = {
    ...GA_DEFAULT_PAYLOAD,
    siteSection: pageContext.siteSection,
    ...defaultPayload,
  };

  return (trackPayload: TrackingPayload) => {
    trackingApi.setDataLayer(
      {
        ...payload,
        ...trackPayload,
      },
      appContext,
      pageContext.pageType,
    );
  };
};
